// eslint-ignore
export default 
`<Checkbox v-model="checkbox" text="Sample">
<p>Value:{{ checkbox }}</p>


export default {
  components: {
    Checkbox
  },

  data () {
    return {
      checkbox: false,
    }
  }
}`;